import { useState } from 'react';
import type { Dialog, DialogActions, DialogState } from './types';

export function useDialog<T>(): Dialog<T> {
    const [state, setState] = useState<DialogState<T>>({
        data: null,
        mode: null,
        open: false,
    });

    const actions: DialogActions<T> = {
        add(data?: T) {
            setState({ data: data ?? null, mode: 'add', open: true });
        },
        close() {
            setState({ data: null, mode: null, open: false });
        },
        edit(data: T) {
            setState({ data, mode: 'edit', open: true });
        },
        open(data: T) {
            setState({ data, mode: 'open', open: true });
        },
        setState,
    };

    return { actions, state };
}
